import React from 'react';
import { PageHeader } from 'antd';
import RackDeviceForm from './form';
import NetworkToolWrapper from '../../layouts/NetworkToolWrapper';
import { MyBreadcrumb } from 'utils';

export default function RackDeviceCreate() {
  return (
    <NetworkToolWrapper isBranchClientRequired={false}>
      <MyBreadcrumb
        items={[
          { label: 'Home', path: '/' },
          { label: 'Networking Dashboard', path: '/network-dashboard' },
          { label: 'Rack Devices', path: '/rackdevice' },
          { label: 'Create Rack Device', path: '' },
        ]}
      />
      <PageHeader
        ghost={false}
        onBack={() => window.history.back()}
        title="Create Rack Device"
        subTitle=""
      >
        <RackDeviceForm noWrapper />
      </PageHeader>
    </NetworkToolWrapper>
  );
}
